const recommendLabelManagement = () => import('./recommendLabelManagement');
const sensitiveLexiconManagement = () => import('./sensitiveLexiconManagement');
const userUploadNum = () => import('./userUploadNum');
const feedback = () => import('./feedback');


const Router = [
  {
    path: 'recommendLabelManagement',
    name: 'recommendLabelManagement',
    component: recommendLabelManagement,
    meta: {
      title: '审核列表'
    }
  },
  {
    path: 'sensitiveLexiconManagement',
    name: 'sensitiveLexiconManagement',
    component: sensitiveLexiconManagement,
    meta: {
      title: '敏感词库管理'
    }
  },
  {
    path: 'userUploadNum',
    name: 'userUploadNum',
    component: userUploadNum,
    meta: {
      title: '敏感词库管理'
    }
  },
  {
    path: 'feedback',
    name: 'feedback',
    component: feedback,
    meta: {
      title: '意见反馈'
    }
  }
];
export default Router;